import {useEffect, useState} from "react";
import {useDefaultEndpoints} from "../../api/useDefaultEndpoints";

const useLegalEntityInstallment = (state) => {
    const { getEntries } = useDefaultEndpoints('legal-entities');
    const legalEntityId = +state?.legal_entity_id || state?.legal_entity_id?.id;
    const [legalEntities, setLegalEntites] = useState({})

    useEffect(() => {
        if (legalEntityId) {
            getEntries({id: legalEntityId}).then(res => setLegalEntites(() => res[0]));
        }
    }, [legalEntityId]);

    const isiInstallmentOptions = legalEntities?.installment?.length > 0;
    const isCorrectInstallmentData = legalEntities?.installment_api_key
        && legalEntities?.installment_pass_id
        && legalEntities?.installment_shop_id
        && isiInstallmentOptions;

    return { isInstallmentAvailable: isCorrectInstallmentData };
}

export default useLegalEntityInstallment;